import { render } from "./LegacyFlow.vue?vue&type=template&id=075169aa"
import script from "./LegacyFlow.vue?vue&type=script&lang=js"
export * from "./LegacyFlow.vue?vue&type=script&lang=js"
script.render = render

export default script